<div>
  <mat-card>
    <mat-card-content style="text-align: end;">
      <mat-hint style="color: red;">{{showStatus}} </mat-hint>
      @if (showDeactivateToggle && id.value) {
        <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked">Deactivate</mat-slide-toggle>
      }
      @if (showReactivateToggle && id.value) {
        <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked">Reactivate</mat-slide-toggle>
      }
    </mat-card-content>
    <form [formGroup]="chargeForm">
      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Code</mat-label>
          <input matInput formControlName="code" placeholder="Code" autocomplete="off" maxlength="6" required>
          @if (code.touched && code.touched && code.hasError('required')) {
            <mat-error>Code is required</mat-error>
          }
          @if (code.touched && code.touched && code.hasError('pattern')) {
            <mat-error>Code Should be less than 6 characters</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Name" autocomplete="off" required>
          @if (name.touched && name.touched && name.hasError('required')) {
            <mat-error>Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Charge Type</mat-label>
          <mat-select formControlName="type">
            <mat-option [value]="null">None</mat-option>
            @for (c of chargeTypes; track c) {
              <mat-option [value]="c.key">
                {{c.label}}
              </mat-option>
            }
          </mat-select>
          @if (type.touched && type.hasError('required')) {
            <mat-error>Charge Type is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Unit Type</mat-label>
          <mat-select formControlName="unitType">
            <mat-option [value]="null">None</mat-option>
            @for (u of unitTypes; track u) {
              <mat-option [value]="u.key">
                {{u.label}}
              </mat-option>
            }
          </mat-select>
          @if (unitType.touched && unitType.hasError('required')) {
            <mat-error>Unit Type is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Charge Category</mat-label>
          <mat-select formControlName="chargeCategory">
            <mat-option [value]="null">None</mat-option>
            @for (c of chargeCategories; track c) {
              <mat-option [value]="c.key">
                {{c.label}}
              </mat-option>
            }
          </mat-select>
          @if (chargeCategory.touched && chargeCategory.hasError('required')) {
            <mat-error>Charge Category is
            required</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="primary" [disabled]="disableSubmit || (!editPermission && this.id.value) || (!addPermission && !this.id.value)" (click)="save()" style="width: 10%;margin-right: 10px;">Save</button>
        <button mat-button color="cancel" (click)="cancel()" style="width: 10%;">Cancel</button>
      </mat-card-actions>
      <mat-card-content>
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'CHARGE'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </form>
  </mat-card>
</div>